<template>
	<b-modal
		centered
		hide-footer
		hide-header
		id="payment-coming-soon"
		:visible="showModal"
		@hidden="$emit('update:showModal', false)"
	>
		<div class="relativeclass">
			<div
				class="rocket-container d-flex justify-content-center"
				ref="rocketContainer"
			>
				<div
					@click="$emit('update:showModal', false)"
					class="d-flex justify-content-end pointer"
				>
					<img
						class="rotate-on-hover"
						style="position: absolute; right: 3px"
						src="../../assets/newdesign/dashboard/button_close_x.svg"
					/>
				</div>
				<img class="rocket" src="../../assets/newdesign/dashboard/rocket.svg" />
			</div>
			<div class="cmg-soon-txt">COMING SOON</div>
			<div class="txt-cmg-soon pt-1">
				<template v-if="fromInstantInterview">
					Instant Interview is coming soon! Get ready to practice and prepare
					for your interviews anytime.
				</template>
				<template v-else>
					You've used your 2 free interviews. Paid plans will be available soon
					to help you continue preparing.
				</template>
			</div>
			<div class="d-flex justify-content-center cmg-soon-btn pointer">
				<b-button
					@click="launchRocket"
					class="btn btn-secondary candash-addBtn"
					:class="{ 'new-homepage-btn': $route && $route.name === 'Homepage' }"
					>Okay</b-button
				>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	name: "PaymentComingSoonModal",
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		fromInstantInterview: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		launchRocket() {
			this.$emit("update:showModal", false);
		},
	},
};
</script>
<style scoped>
.rocket-container {
	position: relative;
	overflow: hidden;
	height: 144px;
}

.rocket {
	position: absolute;
	bottom: 0;
}

.cmg-soon-txt {
	width: 100%;
	height: 30px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 25px;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
	letter-spacing: 0.16em;
	color: #20639b;
}

.txt-cmg-soon {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	text-align: center;
	color: #5f5f5f;
}

.cmg-soon-btn {
	margin-top: 20px;
}

.new-homepage-btn {
	background-color: #4A7EFF !important;
	border-color: #4A7EFF !important;
}

.rotate-on-hover {
	transition: transform 0.3s ease;
}

.rotate-on-hover:hover {
	transform: rotate(90deg);
}

.pointer {
	cursor: pointer;
}
</style>
